import { render, staticRenderFns } from "./v-ship-station-ism.vue?vue&type=template&id=0bbe85ce&scoped=true&"
import script from "./v-ship-station-ism.vue?vue&type=script&lang=js&"
export * from "./v-ship-station-ism.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe85ce",
  null
  
)

export default component.exports